<template>
  <div class="drug_info_block">
    <div class="flex align-items-center">
      <div class="mr-2">
        <span :class="['priority','priority-' + drug.priority]"></span>
      </div>
      <div class="mr-1 flex flex_gap_10">
        <i v-if="drug.cool" class="icon icon-snowflake"/>
        <v-icon v-if="drug.is_press_can" class="red_icon" name="spray-can"/>
      </div>
      <span>{{ drug.title }}</span>
      <v-popover
        placement="right"
        trigger="hover"
        :delay="{ show: 100, hide: 500 }"
      >
        <span class="badge badge-info pointer">ENG</span>
        <template slot="popover">
          <div>{{ drug.en_title }}</div>
        </template>
      </v-popover>
    </div>
    <template v-for="r in (drug?.drug_relations ?? [])">
      <div v-for="t in (r?.tasks ?? [])">
        <OutsorceCallTask :task="t"/>
      </div>
    </template>
    <p class="text-muted flex flex_gap_5">
      <i v-if="!inModal" @click="openDrugEdit(drug.id)" class="icon-fa icon-fa-edit openEditDrugIcon"/>
      <template v-if="!inModal">
        <template v-for="g in [{group: 'managers_info'}, {group: 'stores_info'}]">
          <v-popover
            v-if="hasDrugComment(drug, g.group)"
            placement="right"
            trigger="hover"
          >
            <i @click="openDrugEdit(drug.id)"
               :class="{
              'icon-fa icon-fa-comment': g.group === 'managers_info',
              'icon-im icon-im-home': g.group === 'stores_info',
              'openEditDrugIcon': true,
              [hasDrugComment(drug, g.group,true)]: true
            }"/>
            <template slot="popover">
              <div>
                <div v-for="c in hasDrugComment(drug, g.group,false, true)">
                  <div v-for="t in c.array_value">
                    <p>{{ t.comment }}</p>
                    <p class="text-muted">{{ t.permanent ? 'бессрочно' : t.valid_date }}</p>
                  </div>
                </div>
              </div>
            </template>
          </v-popover>
        </template>
      </template>
      {{ drug.id }}
      <span class="badge badge-info pack_set_block pull-right" v-if="+drug.pack_set !== 1">комплект: <strong
        class="fs-18">{{ Math.round(drug.pack_set) }}</strong></span></p>
    <p>Страна: <strong>{{ getIncomeCountry() }}</strong></p>
    <p v-for="detail in drug.details.filter((d) => d.group_alias === 'extra' && d.alias === 'country')">
      <strong>{{ getCountryById(detail.int_value).name }}</strong>
    </p>
    <p>Основная валюта закупки: <strong>{{
        $AllCurrencies[drug.income_currency_id] && $AllCurrencies[drug.income_currency_id].currency || 'не найдено'
      }}</strong></p>
    <div class="flex price_blocks">
      <div>
        <div class="big_font flex flex_gap_10">
          <strong><i class="icon-fa icon-fa-eur"/></strong>
          <strong>{{ getDrugCostPrice() }}</strong>
          <div
            v-if="drug.pack_set > 1"><strong>| {{
              Math.round(getCostPriceByInvoices(invoices) * drug.pack_set * 100) / 100
            }}</strong>
          </div>
          <v-popover
            placement="right"
          >
            <span class="badge badge-info pointer color-w"><i class="icon-fa icon-fa-calculator"/></span>
            <template slot="popover">
              <div>
                <div><input type="number" placeholder="Новая себестоимость" v-model="customCostPrice"
                            class="form-control"></div>
                <div class="mt-1 p-1 fs-14" v-if="customCostPrice"
                     v-html="getRecommendedPrice(true, customCostPrice, true, true)"/>
              </div>
            </template>
          </v-popover>
        </div>
        <p>{{
            Math.round(getCostPriceByInvoices(invoices) * +profitCalculation.calculatedRate * 100) / 100
          }}
          руб.</p>
        <div class="flex">
          <v-popover
            placement="left"
            trigger="hover"
          >
            <span class="popover_span">i</span>
            <template slot="popover">
              <div v-html="getRecommendedPrice(true)"/>
            </template>
          </v-popover>
          <strong>{{ getRecommendedPrice() }} руб.</strong>
        </div>
      </div>
      <div class="projected_price_block" v-if="displaySettings?.showIndPrice">
        <p class="big_font"><i class="icon-fa icon-fa-eur"/> {{ drug.projected_price }}</p>
        <p>{{
            Math.round(+(profitCalculation && profitCalculation.calculatedRate || 0) * drug.projected_price)
          }} руб.</p>
        <p><strong>{{ getRecommendedPrice(false, drug.projected_price) }} руб.</strong></p>
      </div>
    </div>
    <div class="mt-2">
      <p v-if="getDetailsByGroup('recipe', 'no_use')"><span class="badge badge-warning">По рецепту</span></p>
      <p v-for="c in getDetailsByGroup('egk')">ЕГК: <strong>{{ c.id }}</strong>
        <span v-if="c.invalid" class="not_valid_code">не активный</span>
      </p>
      <template v-for="(c, i) in getDetailsByGroup('manufacturer')">
        <p v-if="c.pzn">PZN: <strong>{{ c.pzn }}</strong> <span v-if="c.comment">{{ c.comment }}</span>
          <LoadingButton
            v-if="i === 0"
            title='<i class="icon-fa icon-fa-search"></i>'
            :loading="loading"
            type="button"
            :color="$constants.SUCCESS_COLOR"
            :onClick="() => parsePrice(c.pzn)"
            className="btn btn-xs btn-outline-success ml-1"
          />
        </p>
      </template>
      <p v-for="d in getDetailsByGroup( 'registration')" v-if="d.use">
        Регистрация:
        <template v-if="d.type === 0">
          <img src="/assets/icons/infinity.png" style="width:25px">
        </template>
        <template v-else>
          <strong>{{ printDate(d.date, 'DD.MM.YYYY') }}</strong>
        </template>
      </p>
    </div>
    <div v-bind:class="{'valid_dates_block':true, 'flex': smallValidDates, 'flex-wrap':true}"
         v-if="drug.valid_dates && drug.valid_dates.length">
      <p>Сроки годности:</p>
      <p v-for="d in getSortedValidDates()" :key="d.id"><i class="icon-fa icon-fa-calendar-minus-o"/>
        <template v-if="!d.is_active && d.status === 1"><span class="badge badge-dark">удален</span></template>
        {{ printDate(d.expire_date, 'MM.YYYY') }} <span class="text-muted">{{
            d.comment
          }}</span>
        <template v-if="d.status === 2">
          <button class="btn btn-success btn-xs" disabled><i class="icon-fa icon-fa-clock-o"/></button>
        </template>
        <template v-else>
          <LoadingButton
            :title='d.info_only ? `<i class="icon-fa icon-fa-eye-slash"></i>` : `<i class="icon-fa icon-fa-eye"></i>`'
            className="btn btn-default btn-xs"
            :onClick="() => updateExpireDate(d)"
            color="gray"
            :loading="loadingBtns.updateExpire[d.id]"
          />
        </template>
        <template v-if="incomeExpDates[d.shortDate]">
          <span class="badge badge-info">поступление</span>
        </template>
      </p>
    </div>
    <div class="info_block mb-1">
      <div class="flex">
        <div>
          <p v-if="+drug.pack_set !== 1">Количество в зав.уп.</p>
          <p>Всего на складах:</p>
          <div class="flex_gap_5 flex">
            <v-popover
              popoverClass="store_drug_popover"
              popoverInnerClass="store_drug_popover_inner"
              :auto-hide="true"
              placement="right">
              <span
                @click="getStoreDetailsData"
                class="badge badge-info pointer store_qty_badge"><strong>{{
                  Math.round((storeDrugData?.total ?? 0) * 100) / 100
                }}</strong></span>
              <template slot="popover">
                <template v-if="storeDrugDetailsData.loading">
                  <pulse-loader :loading="true" :color="$constants.LOADING_COLOR" class="text-center"/>
                </template>
                <template v-else>
                  <StoreTable
                    v-if="storeDrugDetailsData.data"
                    :allowToGetMoves="true"
                    :hideStoreLink="true"
                    :disableCorrection="true"
                    :selectedDrugs="[drug]"
                    :storeData="storeDrugDetailsData.data"
                  />
                </template>
              </template>
            </v-popover>
            <span
              v-if="storeDrugData && storeDrugData[30]">(+РЦС {{
                storeDrugData && storeDrugData[30]
              }})</span>
            <template v-if="freezeInvoices && Object.keys(freezeInvoices).length">
                <span class="freeze_details_block">({{
                    (storeDrugData && storeDrugData.total || 0) - freezeInvoices.total_qty
                  }} + {{
                    freezeInvoices.total_qty
                  }}* <strong
                    v-bind:class="{red: +freezeInvoices.cost_diff > 0, green: freezeInvoices.cost_diff < 0}">( <i
                    class="icon-fa icon-fa-eur"/> {{
                      freezeInvoices.cost_diff
                    }})</strong>)</span>
            </template>
          </div>
          <p>M: <strong>{{ storeDrugData && storeDrugData[3] || 0 }}</strong>
            <button class="btn-xs btn-default" type="button" @click="openStoreTrends">
              <i class="icon-fa icon-fa-line-chart"></i>
              <!--              <i class="icon-fa icon-fa-area-chart"></i>-->
              <!--              <i class="icon-fa icon-fa-bar-chart-o"></i>-->
            </button>
          </p>
          <div v-html="getRequestedQty()"/>
          <template v-if="+drug.combined_type === 2">
            <p><span class="badge badge-info">Это компонент и не активен для продажи</span></p>
          </template>
          <template v-if="+drug.combined_type === 1">
            <p><span class="badge badge-info">Препарат состоит из компонетов</span></p>
            <p v-for="cd in drug.combined_drugs">{{ cd.drug.id }} <strong>{{ cd.drug.title }}</strong> ( x
              {{ cd.rate }})
              <span
                class="badge badge-info">{{
                  (allStoreDrugsData && allStoreDrugsData[cd.combine_drug_id]?.total) ?? 0
                }}</span> M:
              <strong>{{ (allStoreDrugsData && allStoreDrugsData[cd.combine_drug_id]?.[3]) ?? 0 }}</strong></p>
          </template>
          <OrderedInvoices
            v-if="ordered && ordered.length"
            :orders="ordered"
            :costPriceCalculation="(costPrice) => getRecommendedPrice(true, costPrice, true, true)"
            :costPrice="getCostPriceByInvoices(invoices)"
          />
        </div>
      </div>
      <div class="flex justify-content-between" v-if="allowToOrder">
        <v-popover
          placement="top"
          :auto-hide="true">
          <button
            @click="getSupplierPrices()"
            class="btn btn-default btn-xs border-r-0"
          >
            цены
          </button>
          <template slot="popover">
            <pulse-loader :loading="pricesLoading" :color="$constants.LOADING_COLOR" class="text-center"/>
            <template v-if="!pricesLoading && supplierPrices">
              <div v-if="!supplierPrices.success">
                {{ supplierPrices.message }}
              </div>
              <div v-else>
                <p>{{ supplierPrices.data.title }}</p>
                <p>Мин.цена: <strong>{{ supplierPrices.data.min_price }}</strong></p>
                <p>Средн.цена: <strong>{{ supplierPrices.data.avage_price }}</strong></p>
                <p>Кол.предложений: <strong>{{ supplierPrices.data.offers_num }}</strong></p>
                <p>{{ printDate(supplierPrices.data.date) }}</p>
              </div>
            </template>
          </template>
        </v-popover>
        <button type="button" @click="() => onOrderSelect(drug.id)" class="btn btn-default btn-xs">заказать
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import store from "@/store";
import Popover from 'vue-js-popover'
import OrderedInvoices from "@/views/nomenclature/components/details/OrderedInvoices";
import api from "@/api";
import StoreTable from "@/views/stores/components/StoreTable.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import OutsorceCallTask from "@/components/drugs/tasks/OutsorceCallTask.vue";
import moment from 'moment';

export default {
  props: ['drug', 'ordered', 'displaySettings', 'allStoreDrugsData', 'ordersStat', 'combineInvoices', 'smallValidDates', 'invoices', 'inModal', 'allowToOrder', 'onOrderSelect', 'profitCalculation', 'freezeInvoices', 'storeDrugData', 'soldData'],
  components: {
    OutsorceCallTask,
    LoadingButton,
    OrderedInvoices,
    StoreTable,
    Popover,
  },
  data() {
    return {
      customCostPrice: null,
      requiredQty: 1,
      incomeExpDates: {},
      storeDrugDetailsData: {loading: false, data: null},
      supplierPrices: null,
      pricesLoading: false,
      loading: false,
      loadingBtns: {
        updateExpire: {}
      },
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllCountries() {
      return this.$store.getters['platform/countries']
    },
  },
  watch: {
    'storeDrugData': {
      handler: function (val, oldVal) {
        this.requiredQty = this.getRequestedQty(true)
      },
      deep: true
    },
  },
  mounted() {
    this.requiredQty = this.getRequestedQty(true);
  },
  created() {
    this.incomeExpDates = this.invoices.reduce((acc, i) => {
      if (i.status === 0 && !moment(i.delivery_date).isAfter(moment().subtract(90, 'days'))) return acc;
      (i.extra_data?.expire_dates ?? []).forEach((d) => {
        if (d) acc[d] = true;
      })
      return acc;
    }, {})
  },
  methods: {
    openStoreTrends() {
      if (!this.soldData) return;
      if (!this.soldData?.options) this.$set(this.soldData, 'options', {showStoreTrend: false});
      this.soldData.options.showStoreTrend = !this.soldData.options.showStoreTrend;
      // store.dispatch('platform/setGlobalDrawerData', {
      //   data: {drug: this.drug, type: 'storeDrugTrends'}
      // });
    },
    hasDrugComment(drug, group, checkOverdue = false, returnComments = false) {
      // console.log(group);
      const details = (drug.details ?? []).filter((d) => d.group_alias === group && d.alias === 'comments' && d.array_value.find((r) => r.comment));
      if (!checkOverdue && !returnComments) return details.length;
      const today = moment();
      if (checkOverdue) {
        return details.reduce((acc, d) => {
          (d.array_value ?? []).forEach((c) => {
            if (!c.permanent && today > moment(c.valid_date, 'DD.MM.YYYY')) acc = 'icon_red';
          })
          return acc;
        }, 'icon_orange')
      }
      return details;
    },
    async updateExpireDate(record) {
      this.loadingBtns.updateExpire[record.id] = true;
      this.loadingBtns = {...this.loadingBtns};
      record.info_only = +!record.info_only;
      let {data} = await api.post('/drugs/updateExpireDates', {
        drugId: record.drug_id,
        action: 'clear_update',
        actualDates: [record]
      })
      if (data.success) {
        const index = this.drug.valid_dates.findIndex((r) => r.id === record.id);
        this.drug.valid_dates[index] = record;
        toastr['success']('Сохранено');
      } else {
        toastr['warning'](data.message ?? 'ошибка сервера', 'Неуспешно')
      }
      this.loadingBtns.updateExpire[record.id] = false;
      this.loadingBtns = {...this.loadingBtns};
    },
    getCostPriceByInvoices(invoices) {
      let i = invoices.find((ii) => +ii.status === 0 && +ii.type === 1);
      if (!i) {
        i = invoices.find((ii) => +ii.status === 5 && +ii.type === 1);
      }
      return +(i?.cost_price ?? 0);
    },
    getDrugCostPrice() {
      if (this.drug.combined_type === 1) {
        let costPrice = 0;
        (this.drug.combined_drugs ?? []).forEach((d) => {
          costPrice += (this.combineInvoices?.[d.combine_drug_id]?.cost_price ?? 0) * d.rate;
        })
        return costPrice;
      }
      if (this.invoices.length) {
        let lastInvoicePrice = (this.invoices.filter((i) => i.status === 0)?.[0]?.cost_price ?? 0);
        if (!lastInvoicePrice) {
          lastInvoicePrice = (this.invoices.filter((i) => i.status === 5)?.[0]?.cost_price ?? 0);
        }
        return Math.round(lastInvoicePrice * 100) / 100;
      }
      return 0;
      // return (this.invoices.length && Math.round(this.invoices[0].cost_price * 100) / 100) ?? 0
    },
    async parsePrice(pzn) {
      this.loading = true;
      const {data} = await api.index('/new/suppliers/parse/' + pzn);
      if (data.success) {
        toastr['success']('Парсинг начался', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    },
    async getStoreDetailsData() {
      if (this.storeDrugDetailsData.loading || this.storeDrugDetailsData.data) return;
      this.storeDrugDetailsData.loading = true;
      console.log('get');
      const {data} = await api.index('/store/drugData?drugId=' + this.drug.id);
      if (data.success) {
        this.storeDrugDetailsData.data = data.storeData;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.storeDrugDetailsData.loading = false;
    },
    async getSupplierPrices() {
      if (this.supplierPrices) return;
      this.pricesLoading = true;
      const {data} = await api.index('/new/drugs/parser/price?id=' + this.drug.id);
      if (!data.success) {
        this.supplierPrices = {message: data.message};
      } else {
        this.supplierPrices = data;
      }
      this.pricesLoading = false;
    },
    openDrugEdit(drugId) {
      store.dispatch('modals/setSideData', {drugId: drugId, type: 'editDrug'})
    },
    getCountryById(id) {
      const country = this.$AllCountries.find((c) => c.id === +id);
      return country || {name: 'не определено'}
    },
    getIncomeCountry() {
      const country = this.$AllCountries.find(c => c.id === this.drug.income_country_id)
      return country && country.name || 'Не указано'
    },
    getRecommendedPrice(calculation = false, customPrice = null, showResult = false, withReverseCalculation = false) {
      let invoices = (this.invoices ?? []).filter((i) => +i.type === 1 && +i.status === 0)
      if (!invoices.length) {
        invoices = (this.invoices ?? []).filter((i) => i.status === 5);
      }
      invoices = _.orderBy(invoices.map((i) => {
        return {...i, timestamp: moment(i.delivery_date).unix()}
      }), ['timestamp', 'id'], ['desc', 'desc']);

      let costPrice = customPrice ?? invoices?.[0]?.cost_price ?? 0;
      // console.log(costPrice, customPrice, this.invoices.length, this.invoices);
      let price = costPrice * this.drug.pack_set * +(this.profitCalculation && this.profitCalculation.calculatedRate || 0);
      price += (price * +(this.profitCalculation && this.profitCalculation.baseMargin || 0) / 100) + +(this.profitCalculation && this.profitCalculation.delivery || 0)
      let dividePercentage = 1 - ((this.profitCalculation.deliveryPercent ?? 0) / 100);
      // console.log(dividePercentage);
      // price += (price * (this.profitCalculation && this.profitCalculation.deliveryPercent || 0) / 100);
      price /= dividePercentage;

      if (calculation) {
        const packSet = this.drug.pack_set > 1 ? Math.round(this.drug.pack_set) + '(K) *' : '';
        let line = '<p>';
        if (this.displaySettings?.showDetailedPercentCalculation) {
          line += `(${costPrice} * ${packSet} ${Math.round((this.profitCalculation && this.profitCalculation.calculatedRate || 0) * 100) / 100} + ${(this.profitCalculation && this.profitCalculation.baseMargin || 0)}%
         + ${(this.profitCalculation && this.profitCalculation.delivery || 0)}) / (<b><u>1</u></b> - ${(this.profitCalculation && this.profitCalculation.deliveryPercent || 0)}/<b><u>100</u></b>)`
            + `${showResult ? ' = <strong>' + (Math.round(price * 100) / 100) + '</strong>' : ''}`;
          line += '</p>';

          if (withReverseCalculation) {
            this.drug.prices.filter((p) => p.site_id === 1 && p.is_active === 1).forEach((p) => {
              line += '<p>' + `${p.price} * (<b><u>1</u></b> - ${this.profitCalculation.deliveryPercent} / <b><u>100</u></b>) - ${this.profitCalculation.delivery} / ${this.profitCalculation.calculatedRate} / ${costPrice} - <b><u>1 * 100</u></b>` + '</p>'
                + '<p><strong>' + p.price + ' => '
                + Math.round((((p.price * (1 - (+this.profitCalculation.deliveryPercent / 100)) - +this.profitCalculation.delivery) / +this.profitCalculation.calculatedRate / costPrice - 1) * 100))
                + `%</strong></p>`;
            })
          }
        } else {
          line += `100% => <strong>${Math.round(price * 100) / 100}</strong></p>`;
          if (withReverseCalculation) {
            this.drug.prices.filter((p) => p.site_id === 1 && p.is_active === 1).forEach((p) => {
              line += `<p>${p.price} => <strong>${Math.round((((p.price * (1 - (+this.profitCalculation.deliveryPercent / 100)) - +this.profitCalculation.delivery) / +this.profitCalculation.calculatedRate / costPrice - 1) * 100))}%</strong></p>`;
            });
          }
        }
        return line;
      }
      return Math.round(price * 100) / 100;
    },
    getDetailsByGroup(groupAlias, detail = null) {
      const details = this.drug.details.reduce((acc, d) => {
        if (d.group_alias === groupAlias) {
          const index = d.group_parent_id || 0;
          if (!acc[index]) acc[index] = {};
          acc[index][d.alias] = d[d.type + '_value'];
          if (d.invalid) {
            acc[index].invalid = d.invalid;
          }
        }
        return acc;
      }, {})
      if (detail) {
        return !((details && details[0]?.no_use) ?? true);
      }
      return Object.values(details);
    },
    getRequestedQty(positiveFigures = false) {
      // let soldData = this.soldData && this.soldData[1] ? (this.soldData[1].total + this.soldData[2].total) : 0
      let soldData = Object.values(this.soldData ?? {}).reduce((acc, s) => acc + (s.total ?? 0), 0);
      soldData = Math.round(soldData / 180 * 75);
      // soldData = this.drug.request_qty;
      let className = 'green';
      if (this.storeDrugData) {
        if (+(this.storeDrugData && this.storeDrugData.total || 0) > soldData) {
          className = 'green';
        } else if (+(this.storeDrugData && this.storeDrugData.total || 0) === soldData) {
          className = '';
        } else {
          className = 'red';
        }
      }
      const inStores = this.storeDrugData && this.storeDrugData.total || 0
      // let drugRequest = +this.drug.request_qty;
      let drugRequest = inStores - soldData - (this.ordersStat?.progress?.drugs ?? 0);
      // console.log(inStores, soldData, drugRequest, this.ordersStat?.progress?.drugs);
      if (positiveFigures) {
        // console.log(drugRequest);
        return Math.round(drugRequest);
        if (inStores < soldData) {
          return soldData - inStores;
        } else {
          return 1;
        }
      }
      let html = `<p class="mb-1">На 75 дней: <strong class="sale_data_req">${soldData}</strong></p>`
      // let drugRequest = this.drug.request_qty + (this.ordersStat?.progress?.drugs ?? 0);
      // if (inStores < soldData) {
      if (drugRequest < 0) {
        // html += `<p class="mb-1 sale_data_req green">Дозаказать <strong>${soldData - inStores}</strong></p>`
        html += `<p class="mb-1 sale_data_req green">Дозаказать <strong>${Math.round(drugRequest) * -1}</strong></p>`
      } else {
        // html += `<p class="mb-1 sale_data_req red">Излишек <strong>${inStores - soldData}</strong></p>`
        html += `<p class="mb-1 sale_data_req red">Излишек <strong>${Math.round(drugRequest)}</strong></p>`
      }
      return html
    },
    getSortedValidDates() {
      let dates = _.orderBy(this.drug.valid_dates.filter((d) => d.is_active || (!d.is_active && d.status === 2)).map((r) => {
        return {...r, shortDate: moment(r.expire_date).format('MM.YYYY')}
      }), 'expire_date')
      if (!dates.length && this.drug.valid_dates.length) {
        dates = [_.orderBy(this.drug.valid_dates, 'expire_date', 'desc')[0]];
      }
      return dates;
    },
  }
}

</script>
<style>
.store_drug_popover {
  width: fit-content;
  max-width: fit-content;
  padding: 10px;
}
</style>
<style scoped>
.red_icon {
  fill: red;
}

.fa-icon {
  margin: -3px auto;
  height: 19px;
}

.icon-snowflake {
  display: inline-block;
  /*vertical-align: -webkit-baseline-middle;*/
  width: 17px;
  height: 19px;
  background: #5bbfde;
  margin: -3px auto;
  mask: url(/assets/svg/snowflake-solid.svg);
}

.priority {
  width: 12px;
  height: 12px;
  border-radius: 20px;
  display: inline-flex;
}

.priority.priority-1 {
  background-color: red;
}

.priority.priority-2 {
  background-color: yellow;
}

.priority.priority-3 {
  background-color: green;
}

.priority.priority-4 {
  background-color: gray;
}

.priority.priority-5 {
  background-color: black;
}

.big_font {
  font-size: 20px;
}

.price_blocks div {
  padding-right: 10px;
}

.icon-fa.icon_orange,
.icon-im.icon_orange {
  background-color: orange;
}

.icon-im.icon_red,
.icon-fa.icon_red {
  background-color: red;
}

.openEditDrugIcon {
  color: white;
  background-color: #5bbfde;
  padding: 3px 4px;
  cursor: pointer;
  font-weight: 700;
  border-radius: 4px;
  text-align: center;
}

.pack_set_block {
  font-size: 12px;
}

.info_block {
  border: 1px solid lightgray;
  padding: 5px;
}

.popover_span {
  color: white;
  background-color: #5bbfde;
  padding: 2px 9px;
  cursor: pointer;
  font-weight: 700;
  border-radius: 4px;
}

.projected_price_block {
  padding-left: 10px;
  border-left: 1px solid lightgray;
}

.freeze_details_block strong {
  font-size: 12px;
}

.freeze_details_block strong.red {
  color: red;
}

.freeze_details_block strong.green {
  color: green;
}

.fs-18 {
  font-size: 18px;
}

.not_valid_code {
  color: red;
  font-weight: 700;
}

.valid_dates_block p {
  margin-right: 3px;
}

.valid_dates_block span {
  overflow-wrap: anywhere;
}

.btn-xs {
  padding: 3px 10px !important;
}

.drug_info_block {
  text-align: left;
}

.store_qty_badge {
  font-size: 14px;
}
</style>
